import { Space, Typography } from "@p0security/ui";
import type { PropsWithChildren } from "react";
import type React from "react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorDisplay } from "../../Error";
import ContactSupport from "../../Integrations/components/ContactSupport";

const fallbackRender = ({ error }: { error: Error }) => (
  <Space direction="vertical" role="alert">
    <ErrorDisplay error={error} />
    <Typography.Text>
      If this error persists, please <ContactSupport />
    </Typography.Text>
  </Space>
);

/**
 * This component wraps our ErrorDisplay component in an ErrorBoundary.
 * The ErrorDisplay component is used to display red error message at the top
 * of the page to the user.
 */
export const ErrorBoundaryDisplay: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  );
};
